const defaultBoundingBox = [
  [-112.33258824909639, 33.251240124992094],
  [-111.59640811140254, 33.692865880979596]
]

const arizonaBoundingBox = [
  [-114.8165, 31.3325],
  [-109.0452, 37.0042]
]
const centerOfUS = { lat: 39.8282, lon: -98.5795 }
const defaultCenterLngLat = [-111.962155, 33.428709] // ARMLS
const phoenixMountainPreserve = [-112.0165, 33.5559]
const imageSizes = ['640x480', '1280x1024', '2048x1600']
const sortByOptions = [
  {
    value: 'logicalStatus',
    label: 'Status'
  },
  {
    value: 'statusDate',
    label: 'Status Date'
  },
  {
    value: 'price',
    label: 'Price'
  },
  {
    value: 'sqFt',
    label: 'Sq Ft'
  },
  {
    value: 'lotSqFt',
    label: 'Lot Size'
  },
  {
    value: 'yearBuilt',
    label: 'Year Built'
  }
]

const orderByOptions = [
  {
    value: 'asc',
    label: 'Ascending'
  },
  {
    value: 'desc',
    label: 'Descending'
  }
]

const deedFields = [
  'Sale Date',
  'Buyers',
  'Sellers',
  'Sale Price',
  'Down Payment',
  'Mortgage Amount',
  'Deed Type',
  'Financing Type',
  'Transaction Type',
  'Mortgage Company',
  'Document Number',
  'Is Verified',
  'Sale Comparison Code'
]

const noticeFields = [
  'Date',
  'Desc.',
  'Notice Doc. #',
  'Trust Deed Doc. #',
  'Trust Deed File Date',
  'Trustee',
  'Beneficiary Name',
  'Original Owner Name',
  'Buyer Name',
  'Buyer Sale Price',
  'Source Updated On',
  'Status',
  'Original Mortgage Balance',
  'Last Transaction Date',
  'Trustee Sale #',
  'Auction Loc. Id',
  'Auction Date',
  'Auction Time',
  'Auction Open Bid Amount',
  'Bid Activity',
  'Bid Ratio'
]

const loanFields = [
  'Loan Date',
  'Mortgage Amount',
  'Mortgage Company',
  'Document Number',
  'Financing Type',
  'Borrower'
]
const compareConstraints = {
  min: 1,
  max: 10
}

const defaultPropEvalFilterVals = {
  distance: 0.5,
  date: 12
}

const USStates = [
  {
    label: 'Alabama',
    value: 'AL'
  },
  {
    label: 'Alaska',
    value: 'AK'
  },
  {
    label: 'American Samoa',
    value: 'AS'
  },
  {
    label: 'Arizona',
    value: 'AZ'
  },
  {
    label: 'Arkansas',
    value: 'AR'
  },
  {
    label: 'California',
    value: 'CA'
  },
  {
    label: 'Colorado',
    value: 'CO'
  },
  {
    label: 'Connecticut',
    value: 'CT'
  },
  {
    label: 'Delaware',
    value: 'DE'
  },
  {
    label: 'District Of Columbia',
    value: 'DC'
  },
  {
    label: 'Florida',
    value: 'FL'
  },
  {
    label: 'Georgia',
    value: 'GA'
  },
  {
    label: 'Guam',
    value: 'GU'
  },
  {
    label: 'Hawaii',
    value: 'HI'
  },
  {
    label: 'Idaho',
    value: 'ID'
  },
  {
    label: 'Illinois',
    value: 'IL'
  },
  {
    label: 'Indiana',
    value: 'IN'
  },
  {
    label: 'Iowa',
    value: 'IA'
  },
  {
    label: 'Kansas',
    value: 'KS'
  },
  {
    label: 'Kentucky',
    value: 'KY'
  },
  {
    label: 'Louisiana',
    value: 'LA'
  },
  {
    label: 'Maine',
    value: 'ME'
  },
  {
    label: 'Maryland',
    value: 'MD'
  },
  {
    label: 'Massachusetts',
    value: 'MA'
  },
  {
    label: 'Michigan',
    value: 'MI'
  },
  {
    label: 'Minnesota',
    value: 'MN'
  },
  {
    label: 'Mississippi',
    value: 'MS'
  },
  {
    label: 'Missouri',
    value: 'MO'
  },
  {
    label: 'Montana',
    value: 'MT'
  },
  {
    label: 'Nebraska',
    value: 'NE'
  },
  {
    label: 'Nevada',
    value: 'NV'
  },
  {
    label: 'New Hampshire',
    value: 'NH'
  },
  {
    label: 'New Jersey',
    value: 'NJ'
  },
  {
    label: 'New Mexico',
    value: 'NM'
  },
  {
    label: 'New York',
    value: 'NY'
  },
  {
    label: 'North Carolina',
    value: 'NC'
  },
  {
    label: 'North Dakota',
    value: 'ND'
  },
  {
    label: 'Ohio',
    value: 'OH'
  },
  {
    label: 'Oklahoma',
    value: 'OK'
  },
  {
    label: 'Oregon',
    value: 'OR'
  },
  {
    label: 'Palau',
    value: 'PW'
  },
  {
    label: 'Pennsylvania',
    value: 'PA'
  },
  {
    label: 'Puerto Rico',
    value: 'PR'
  },
  {
    label: 'Rhode Island',
    value: 'RI'
  },
  {
    label: 'South Carolina',
    value: 'SC'
  },
  {
    label: 'South Dakota',
    value: 'SD'
  },
  {
    label: 'Tennessee',
    value: 'TN'
  },
  {
    label: 'Texas',
    value: 'TX'
  },
  {
    label: 'Utah',
    value: 'UT'
  },
  {
    label: 'Vermont',
    value: 'VT'
  },
  {
    label: 'Virgin Islands',
    value: 'VI'
  },
  {
    label: 'Virginia',
    value: 'VA'
  },
  {
    label: 'Washington',
    value: 'WA'
  },
  {
    label: 'West Virginia',
    value: 'WV'
  },
  {
    label: 'Wisconsin',
    value: 'WI'
  },
  {
    label: 'Wyoming',
    value: 'WY'
  }
]

const jellyBeans = [
  { id: 1, start: '#AF2731', stop: '#DD4A53' },
  { id: 2, start: '#C73F61', stop: '#F088A2' },
  { id: 3, start: '#E06D6D', stop: '#FFA3A4' },
  { id: 4, start: '#8B3C7B', stop: '#AD4D9A' },
  { id: 5, start: '#7743A7', stop: '#A994BD' },
  { id: 6, start: '#7B7489', stop: '#B9B7BD' },
  { id: 7, start: '#5560A2', stop: '#8091FE' },
  { id: 8, start: '#3B5DB2', stop: '#3B5DB2' },
  { id: 9, start: '#3B5DB2', stop: '#638FFF' },
  { id: 10, start: '#5985AD', stop: '#87A5C1' },
  { id: 11, start: '#187AAD', stop: '#67A7C9' },
  { id: 12, start: '#3A8FAC', stop: '#02BBFA' },
  { id: 13, start: '#678989', stop: '#3D5B5A' },
  { id: 14, start: '#2F8081', stop: '#37A3A5' },
  { id: 15, start: '#55807E', stop: '#71ACAA' },
  { id: 16, start: '#6AAA94', stop: '#B6E2D3' },
  { id: 17, start: '#467426', stop: '#568C2F' },
  { id: 18, start: '#2FA54B', stop: '#5CC976' },
  { id: 19, start: '#6FAF30', stop: '#98D55B' },
  { id: 20, start: '#CEAD1A', stop: '#E3BF07' },
  { id: 21, start: '#C36F1B', stop: '#FF8202' },
  { id: 22, start: '#72551B', stop: '#A87F56' },
  { id: 23, start: '#674831', stop: '#B2A496' },
  { id: 24, start: '#8B857D', stop: '#B4AFA9' },
  { id: 25, start: '#333', stop: '#777' },
  { id: 26, start: '#727B7E', stop: '#A9B1B4' }
]

const statusChanges = [
  'New Listing',
  'On Market',
  'Under Contract',
  'Off Market',
  'Deleted',
  'Sold'
]

const connectedRegGuestStatuses = [
  {
    display: 'Cancelled',
    icon: 'slate',
    color: '#484848',
    keys: [
      {
        value: 2,
        name: 'cancelled'
      }
    ]
  },
  {
    display: 'Coming Soon',
    icon: 'darkTeal',
    color: '#007AAA',
    keys: [
      {
        value: 14,
        name: 'comingSoon'
      }
    ]
  },
  {
    display: 'Temp Off Market',
    icon: 'gold',
    color: '#FFCC00',
    keys: [
      {
        value: 7,
        name: 'tempOffMarket'
      }
    ]
  },
  {
    display: 'Expired',
    icon: 'red',
    color: '#D1101A',
    keys: [
      {
        value: 5,
        name: 'expired'
      }
    ]
  }
]

const excludedRoutes = [
  '/connections/:type/:id/:choice',
  '/opt-out',
  '/terms',
  '/eula',
  '/privacy',
  '/tax-detail-form'
]

const guidedTours = {
  listing: {
    steps: [
      {
        target: '#photoCentricViewToggle',
        image: 'photo_icon.gif',
        title: 'Photo View',
        content: 'Large photos with Listing info and a Public Records Summary.'
      },
      {
        target: '#dataCentricViewToggle',
        image: 'data_icon.gif',
        title: 'Data View',
        content: 'Complete Listing Details including Documents and Open Houses.'
      },
      {
        target: '#taxViewToggle',
        image: 'tax_icon.gif',
        title: 'Tax View',
        content:
          'Complete Public Records information with Deed, Loan, and Tax History.'
      },
      {
        target: '#parcelViewToggle',
        image: 'parcel_icon.gif',
        title: 'Parcel View',
        content: 'Public Records summary with a complete Listing History.'
      }
    ]
  },
  parcel: {
    steps: [
      {
        target: '#taxViewToggle',
        image: 'tax_icon.gif',
        title: 'Tax View',
        content:
          'Complete Public Records information with Deed, Loan, and Tax History.'
      },
      {
        target: '#parcelViewToggle',
        image: 'parcel_icon.gif',
        title: 'Parcel View',
        content: 'Public Records summary with a complete Listing History.'
      }
    ]
  }
}

const searchResultsLimits = {
  markers: 500,
  cards: 500
}

const domain =
  import.meta.env.REACT_APP_AWS_DOMAIN || import.meta.env.REACT_APP_DOMAIN

/** Protocol for app links/redirects: https in production, http in development */
const appProtocol =
  // eslint-disable-next-line no-nested-ternary
  typeof window !== 'undefined' && window.location?.protocol === 'https:'
    ? 'https'
    : import.meta.env.MODE === 'development'
      ? 'http'
      : 'https'

export {
  defaultBoundingBox,
  arizonaBoundingBox,
  centerOfUS,
  defaultCenterLngLat,
  sortByOptions,
  orderByOptions,
  imageSizes,
  deedFields,
  noticeFields,
  loanFields,
  compareConstraints,
  defaultPropEvalFilterVals,
  USStates,
  phoenixMountainPreserve,
  jellyBeans,
  statusChanges,
  connectedRegGuestStatuses,
  searchResultsLimits,
  excludedRoutes,
  guidedTours,
  domain,
  appProtocol
}
